var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF0851",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M2.667 18.667s.161 1.132 4.848 5.818c4.686 4.687 12.284 4.687 16.97 0a11.95 11.95 0 0 0 3.217-5.818m-25.035 0v8m0-8h8m18.666-5.334s-.161-1.132-4.848-5.818c-4.686-4.687-12.284-4.687-16.97 0a11.94 11.94 0 0 0-3.217 5.818m25.035 0v-8m0 8h-8"
  })));
};
export default SvgRefresh;